import { normalizeVariant } from "./shipmentsTransformers";

export const getTelemetryViewState = ({ chartsInfo, variant }) => {
  const normalizedVariant = normalizeVariant(variant);

  const fullLength = chartsInfo?.telemetryInfo?.full?.length ?? 0;
  if (fullLength === 0) return { state: "noFull" };

  const list = chartsInfo?.telemetryInfo?.[normalizedVariant] ?? [];
  const ok = Array.isArray(list) && list.length > 0;
  if (!ok) return { state: "noVariant", variant: normalizedVariant };

  return { state: "ok", variant: normalizedVariant };
};

export const getTelemetryViewMessage = ({ state, variant }) => {
  if (state === "noFull") {
    return "El envío no dispone por el momento de registros de telemetría. Por favor, inténtelo de nuevo más tarde.";
  }
  if (state === "noVariant") {
    return `No hay telemetrías disponibles para visualizar en el modo vista ${
      variant === "full" ? "completa" : "reducida"
    }.`;
  }
  return "";
};

export const getStandaloneBlockingState = (shipmentParameters, chartsInfo) => {
  const { file, telemetryTypeCode } = shipmentParameters || {};
  const hasFull = (chartsInfo?.telemetryInfo?.full?.length ?? 0) > 0;

  // 1) Registrado sin datos todavía
  if (!file && !hasFull && telemetryTypeCode === null) {
    return {
      type: "message",
      message: "El pedido se ha registrado pero aún no se han cargado datos.",
    };
  }

  // 2) telemetryTypeCode 1 : Sin datos
  if (!file && telemetryTypeCode === 1) {
    return {
      type: "message",
      message:
        "No se dispone de registro de temperatura del envío debido a que el datalogger retornó a nuestras instalaciones sin que se haya iniciado el proceso de grabación de datos en origen. En caso de cualquier duda o consulta relativa al proceso de inicio de grabación de datos consulta con tu gestor comercial.",
    };
  }

  // 3) telemetryTypeCode 2 : Sin datalogger
  if (!file && telemetryTypeCode === 2) {
    return {
      type: "message",
      message:
        "No se dispone de registro de temperatura del envío debido a que la caja isotérmica retornó a nuestras instalaciones sin datalogger en el interior.",
    };
  }

  // 4) PDF
  if (file && telemetryTypeCode === 3) {
    return { type: "pdf", pdfBase64: file };
  }

  return { type: "none" };
};

export const formatMacDatalogger = (macMando) =>
  macMando ? `(${macMando})` : "";
